// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","736":"vendor"}[chunkId] + "." + {"532":"a555bec61b0c77e705a6","736":"0f53fd2bb039baae25eb"}[chunkId] + ".css";
};